import { render, staticRenderFns } from "./InfoBanner.vue?vue&type=template&id=6e24da62"
import script from "./InfoBanner.vue?vue&type=script&lang=ts"
export * from "./InfoBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports